import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon, Header, Button, Grid, Table } from "semantic-ui-react";
import { toast } from 'react-toastify';
import moment from 'moment';
import Swal from 'sweetalert2';
import UserInfo from '../Common/SharedComponents/UserInfo';
import AdminSidebar from '../Common/SharedComponents/AdminSidebar';
import AppContext, { token_config } from '../../AppContext';
import axiosInstance from '../../helpers/axiosInstance';
import SwitchTheme from '../Common/SharedComponents/SwitchTheme';
import { MSGraphViewModel } from '../../types/ServerDTO';

const Tags: React.FC = () => {
  const navigate = useNavigate();
  const { userInfo } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [msGraphSubscriptions, setMsGraphSubscriptions] = useState<MSGraphViewModel[]>();

  useEffect(() => {
    if (userInfo !== undefined) {
      const privileges: string[] = userInfo ? userInfo.Privileges.split(',') : [];
      if (!privileges.includes(token_config.MANAGE_MS_GRAPH)) {
        navigate('/');
      }
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    document.title = 'MSGraph Subscription - Adjure';
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      await axiosInstance.get('MSGraph/GetSubscription').then(({ data, status }) => {
        if (status === 200) {
          setIsLoading(false);
          setMsGraphSubscriptions(data);
        } else if (status === 204) {
          setIsLoading(false);
          setMsGraphSubscriptions([]);
        }
      })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    } catch (error: any) {
      setIsLoading(false);
      console.log(error);
    }
  }

  const handleMSGraphSubscribe = () => {
    try {
      axiosInstance.post(`/MSGraph/Subscribe`, null).then(async ({ data, status }) => {
        if (status === 200) {
          toast.success('MSGraph subscribed successfully');
          window.location.reload();
        }
      })
        .catch((error) => {
          console.log(error);
        });
    } catch (error: any) {
      console.log(error);
    }
  }

  const handleDeleteMSGraphSubscription = (msGraphSubscriptionId: string) => {
    Swal.fire({
      title: 'Are you sure you want to delete?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axiosInstance.post(`/MSGraph/DeleteSubscription/${msGraphSubscriptionId}`, null).then(async ({ data, status }) => {
            if (status === 200) {
              toast.success('MSGraph subscription deleted successfully');
              window.location.reload();
            }
          })
            .catch((error) => {
              console.log(error);
            });
        } catch (error: any) {
          console.log(error);
        }
      }
    });
  }

  return (
    <section className="section" style={{
      minHeight: '100vh'
    }}>
      <div className="section__head">
        <div className="section__head-content">
          <Header as="h1">MSGraph Subscription</Header>
        </div>
        <div className="section__actions">
          <UserInfo />
          <SwitchTheme />
        </div>
      </div>
      <div className="section__body">
        <Grid padded>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={3} computer={3}>
              <AdminSidebar />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={13} computer={13}>
              {msGraphSubscriptions && msGraphSubscriptions.length > 0 && (
                <div className="table-holder">
                  <Table celled={true} sortable={true} striped={true}>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell style={{ width: '35%' }}>Email</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '40%' }}>Subscription ID</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '25%', textAlign: 'center' }}>Expiration Date</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {msGraphSubscriptions.map((row) => (
                        <Table.Row>
                          <Table.Cell style={{ fontSize: '16px', textAlign: 'left' }}>{row.email}</Table.Cell>
                          <Table.Cell style={{ fontSize: '16px', textAlign: 'left' }}>
                            {row.subscriptionId}
                            {row.subscriptionId === '' && (
                              <>
                                <span>No active subscription</span>
                                <Button title="Subscribe" onClick={handleMSGraphSubscribe} className='violet button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem', color: '#fff', marginLeft: '1rem' }}>Subscribe</Button>
                              </>
                            )}
                          </Table.Cell>
                          <Table.Cell style={{ textAlign: 'center' }}>
                            {row.subscriptionId && (
                              <>
                                <span>{moment(row.expirationDateUTC).format('MMM D, YYYY hh:mm A')}</span>
                                <Icon name='trash' onClick={() => handleDeleteMSGraphSubscription(row.subscriptionId)} style={{ marginLeft: '1rem', cursor: 'pointer', color: '#e15247' }} />
                              </>
                            )}
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                  <div className='mt-2'>Note - Resubscribing will not automatically download the missed messages. They will be downloaded every 24 hours through a email sync job that runs at 12:05 AM every day.</div>
                </div>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </section>
  );
}

export default Tags;